import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { Locale } from 'services/graphql/types';

export default function usePreview() {
  const { pathname, query, push } = useRouter();

  return useMemo(() => {
    const {
      tenant = 'carbonify',
      brandId,
      locale = 'de_DE',
      slug,
      env = 'main',
      drafts,
      edit,
      token,
    } = (query as Record<string, string | undefined>) || {};

    const isPreview = pathname.startsWith('/preview') || false;
    const isBlog = slug && slug?.toString().startsWith('blog/') && slug.length !== 5;

    return {
      isPreview,
      isBlog,
      tenant: (!brandId && tenant) as string,
      brandId,
      locale: locale.replace('-', '_') as Locale,
      slug: isBlog ? slug.substring(5) : slug,
      env,
      drafts: !!parseInt(drafts || '1'),
      edit: !!parseInt(edit || '1'),
      token,
      navigate: (slug: string) => {
        push(
          {
            pathname: 'preview',
            query: {
              ...query,
              slug,
            },
          },
          undefined,
          { shallow: true },
        );
      },
    };
  }, [pathname, query, push]);
}
